import { useEffect, useMemo, useState } from 'react';

import { ReleaseNotesProvider } from '~/modules/release-notes/providers/release-notes';
import { PrivateLayoutProvider } from '~/common/providers/private-layout';
import { BackdropProvider } from '~/common/providers/backdrop';
import { useAuth } from '~/common/providers/auth';
import { IFCWithChildren } from '~/common/interfaces/i-fc-with-children';
import { useMediaQuery } from '~/common/hooks/use-media-query';
import { profilesIds } from '~/common/constants/profiles-ids';

import {
  BodyContainer,
  StyContentWrapper,
  PrivateLayoutContainer,
  StyContainer,
  StyContentContainer,
} from './styles';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';

export const PrivateLayout: IFCWithChildren = ({ children }) => {
  const { user } = useAuth();
  const [openSidebarDrawer, setOpenSidebarDrawer] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width: 750px)');
  const [render, setRender] = useState(false);

  useEffect(() => {
    setRender(true);
  }, []);

  const shouldRenderSidebar = useMemo(() => {
    if (!user) {
      return false;
    }

    if (user.employeeId && user.profile.id === profilesIds.EMPLOYEE) {
      return false;
    }

    return true;
  }, [user]);

  if (!render) return null;

  return (
    <PrivateLayoutProvider isMobile={isMobile}>
      <BackdropProvider>
        <ReleaseNotesProvider>
          <PrivateLayoutContainer>
            <StyContainer>
              {shouldRenderSidebar && (
                <Sidebar
                  openSidebarDrawer={openSidebarDrawer}
                  setOpenSidebarDrawer={setOpenSidebarDrawer}
                />
              )}

              <StyContentContainer>
                <Header
                  openSidebarDrawer={openSidebarDrawer}
                  setOpenSidebarDrawer={setOpenSidebarDrawer}
                />
                <StyContentWrapper>
                  <BodyContainer>{children}</BodyContainer>
                </StyContentWrapper>
              </StyContentContainer>
            </StyContainer>
          </PrivateLayoutContainer>
        </ReleaseNotesProvider>
      </BackdropProvider>
    </PrivateLayoutProvider>
  );
};
